import { useQuery } from "@tanstack/react-query";

import { TeamsListResponse } from "@oracus/shared/api/teams";

import { apiClient } from "./client.ts";

const TEAMS_KEY = ["teams"] as const;

export function useTeams() {
  return useQuery({
    queryKey: TEAMS_KEY,
    queryFn: () => apiClient.get("/api/teams", TeamsListResponse),
  });
}
